import logoSvg from './logo.svg'

export const SvgImageParceirosPrudentialLogo = ( props ) => {
    return (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
            <img
                className='w-full'
                width="190px"
                height="60px"
                src={logoSvg}
                alt={''}
                {...props}
            />
        </div>
    )
}